import { SURVEYS, SURVEY_DETAILS, SURVEY_RESPONSES } from '../config/api';
import { apiCall } from './api';

// Get all surveys
export const getSurveys = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const endpoint = `${SURVEYS}${queryString ? `?${queryString}` : ''}`;
  
  return apiCall(endpoint, {
    method: 'GET'
  });
};

// Get survey by ID
export const getSurveyById = async (surveyId) => {
  const endpoint = SURVEY_DETAILS.replace('{id}', surveyId);
  
  return apiCall(endpoint, {
    method: 'GET'
  });
};

// Create new survey
export const createSurvey = async (surveyData) => {
  return apiCall(SURVEYS, {
    method: 'POST',
    data: surveyData
  });
};

// Update survey
export const updateSurvey = async (surveyId, surveyData) => {
  const endpoint = SURVEY_DETAILS.replace('{id}', surveyId);
  
  return apiCall(endpoint, {
    method: 'PUT',
    data: surveyData
  });
};

// Delete survey
export const deleteSurvey = async (surveyId) => {
  const endpoint = SURVEY_DETAILS.replace('{id}', surveyId);
  
  return apiCall(endpoint, {
    method: 'DELETE'
  });
};

// Get survey responses
export const getSurveyResponses = async (surveyId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const endpoint = `${SURVEY_RESPONSES.replace('{id}', surveyId)}${queryString ? `?${queryString}` : ''}`;
  
  return apiCall(endpoint, {
    method: 'GET'
  });
};

// Submit survey response
export const submitSurveyResponse = async (surveyId, responseData) => {
  const endpoint = SURVEY_RESPONSES.replace('{id}', surveyId);
  
  return apiCall(endpoint, {
    method: 'POST',
    data: responseData
  });
};

// Get survey statistics
export const getSurveyStats = async (surveyId) => {
  const endpoint = `${SURVEY_DETAILS.replace('{id}', surveyId)}/stats`;
  
  return apiCall(endpoint, {
    method: 'GET'
  });
};

// Activate/Deactivate survey
export const toggleSurveyStatus = async (surveyId, status) => {
  const endpoint = `${SURVEY_DETAILS.replace('{id}', surveyId)}/status`;
  
  return apiCall(endpoint, {
    method: 'PATCH',
    data: { status }
  });
};

// Duplicate survey
export const duplicateSurvey = async (surveyId, newTitle) => {
  const endpoint = `${SURVEY_DETAILS.replace('{id}', surveyId)}/duplicate`;
  
  return apiCall(endpoint, {
    method: 'POST',
    data: { title: newTitle }
  });
};
